import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth, AuthClientJsonWebToken, BackEnd, LoginBody } from '@app/interfaces/sys/auth';
import { environment } from '@env/environment';
import { lastValueFrom, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthHttp {

    private moduleApi = environment.api.services.auth;
    private baseUrl = this.moduleApi + '/auth';
    private googleButtonSubject = new Subject();

    googleButtonObservable$ = this.googleButtonSubject.asObservable();

    constructor(private http: HttpClient) { }

    initializeGoogleButton(): void {
        console.log('Google button initialization triggered');
        // @ts-ignore
        this.googleButtonSubject.next();
    }

    login(data: LoginBody): Promise<Auth> {
        return lastValueFrom(this.http.post<Auth>(`${this.baseUrl}?_allow_anonymous=true`, data));
    }


    loginByExternalAuthProvider(data: AuthClientJsonWebToken): Promise<Auth> {
        return lastValueFrom(this.http.post<Auth>(`${this.baseUrl}/external`, data));
    }

    async logout(): Promise<object> {
        return lastValueFrom(this.http.delete(this.baseUrl));
    }

    async current(): Promise<Auth> {
        return lastValueFrom(this.http.get<Auth>(this.baseUrl));
    }

    async getServiceInfo(): Promise<BackEnd[]> {
        return lastValueFrom(this.http.get<BackEnd[]>(`${this.moduleApi}/services`));
    }
}
